import React from 'react';
import { CustomModal } from '@cd/sdds-common-components-react';
import './ConfirmationDialog.scss';
import { useTranslation } from 'react-i18next';

type ConfirmationDialogPropsType = {
    onClose: () => void;
    onAction: () => void;
    title: string;
    confirmationMsg: string;
    name: string;
    email: string;
    primaryActionBtn: string;
    secondaryActionBtn: string;
    isDelete?: boolean
};

const ConfirmationDialog = (props: ConfirmationDialogPropsType) => {

    const { title, confirmationMsg, onClose, onAction, primaryActionBtn, secondaryActionBtn, isDelete, name, email } = props;
    const { t } = useTranslation();
    return (
        <div className='confirmationDialogContainer'>
            <CustomModal
                id="confirmationDialog"
                show={true}
                title={title}
                handleClose={onClose}
                size="xs"
                actions={(
                    <>
                        <button type="button" className="sdds-btn sdds-btn-sm sdds-btn-secondary bttn sdds-u-mb2" onClick={onClose} >{secondaryActionBtn}</button>
                        <button type="button" className={`sdds-btn sdds-btn-sm ${isDelete ? "sdds-btn-danger" : "sdds-btn-primary"} bttn sdds-u-mb2`} onClick={onAction}>{primaryActionBtn}</button>
                    </>
                )}
            >
                <div className="confirmationDialogContent sdds-detail-02">
                    <span>{confirmationMsg}</span>
                    <div className='spacing'>
                        <span><strong>{t('TS_core:Name')}:</strong>{name}</span>
                        <span><strong>{t('TS_core:EmailAddress')}:</strong>{email}</span>
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

export default ConfirmationDialog;